import React from 'react';

const ImprintContent: React.FC = () => (
    <>
        <div className="content relative w-full">
            <div id="content" className="wpContent mb-10 text-base">
                <h1>Imprint / Impressum</h1>

                <p>
                    <br />
                    <strong>
                        Angaben gemäß § 5 TMG
                        <br />
                    </strong>
                    <br />
                    Adrian Stanek Karl-Friedrich-Straße 6<br />
                    77977 Rust
                </p>

                <p>
                    <strong>Kontakt</strong>
                    <br />
                    E-Mail: info@adrianstanek.dev
                    <br />
                </p>

                <p>
                    <strong>Redaktionell verantwortlich</strong>
                    <br />
                    Adrian Stanek
                    <br />
                    Karl-Friedrich-Straße 6<br />
                    77977 Rust
                </p>

                <p>
                    <br />
                    <strong>Quelle</strong>:<br />
                    https://www.e-recht24.de
                </p>
            </div>

            <div>
                <h2 className="mt-2 text-primary">Bildnachweise / Licencing-References</h2>
                Adobe Stock Account: Adrian247668765lsk
            </div>
        </div>
    </>
);

export default ImprintContent;
